import { Box, withStyles } from '@material-ui/core';
import FsCaption from 'ui-elements/typography/FsCaption';
import FsBody from 'ui-elements/typography/FsBody';

export const Caption = withStyles(({ palette, spacing }) => ({
  root: {
    color: palette.grey[300],
    marginBottom: spacing(1.5),
    display: 'block',
  },
}))(FsCaption);

export const Sentence = withStyles(() => ({
  root: {
    fontWeight: 300,
    fontSize: 24,
    whiteSpace: 'nowrap',
  },
}))(FsBody);

export const SelectWrapper = withStyles(() => ({
  root: {
    display: 'inline-block',
    transform: `translateY(3px)`,
  },
}))(Box);
